/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfiguratorAttributeCompositionConfig } from '../composition/configurator-attribute-composition.config';
import { ConfiguratorAttributeFooterComponent } from './configurator-attribute-footer.component';
import {I18nModule, provideDefaultConfig} from "@lm-nx-frontend/lm-inf-core";
import {IconModule} from "@lm-nx-frontend/lm-inf-ui";

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    I18nModule,
    IconModule,
  ],
  providers: [
    provideDefaultConfig(<ConfiguratorAttributeCompositionConfig>{
      productConfigurator: {
        assignment: {
          Footer: ConfiguratorAttributeFooterComponent,
        },
      },
    }),
  ],
  declarations: [ConfiguratorAttributeFooterComponent],
  exports: [ConfiguratorAttributeFooterComponent],
})
export class ConfiguratorAttributeFooterModule {}
